import { Action } from 'redux';

import { TThunkAction } from '../../types/redux';
import { FILTERS_SET_VILLAGE_TYPE } from '../../constants/action_types';
import { getMeta } from './getMeta';

export type TSetVillageType = 'filters/set_village';

export interface ISetVillage extends Action<TSetVillageType> {
  type: TSetVillageType;
  villageId: number | undefined;
}

export type TSetVillage = ISetVillage;

export function setVillage(villageId: number | undefined): TThunkAction {
  return dispatch => {
    dispatch<TSetVillage>({
      type: FILTERS_SET_VILLAGE_TYPE,
      villageId,
    });

    dispatch(getMeta());
  };
}
